import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as Actions from './actions';

const Balances = Record({
    billPayerIds: List(),
    fetching: false,
});

export default handleActions(
    {
        [Actions.fetchAll.type]: state =>
            state.merge({
                billPayerIds: List(),
                fetching: true,
            }),
        [Actions.fetchAllSuccess.type]: (state, {payload}) =>
            state.merge({
                billPayerIds: payload.billPayers.map(bp => bp.billPayerId),
                fetching: false,
            }),
        [Actions.fetchAllFailed.type]: state =>
            state.merge({
                fetching: false,
            }),
    },
    new Balances(),
);
